// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__26N6e","content":"Consent_content__2pftD","footer":"Consent_footer__11aLf"};